export default "__VITE_ASSET__nvqp65WE__"